import '../scss/styles.scss';

window.gmload = false;
window.ytallowed = false;
window.vimallowed = false;

import { Usercentrics } from "./general/usercentrics";

import initFormVue from "./forms/formVueForms";
import './contentelements/eventsListFilter';

import WindowEvents from './page/window-events';
import LanuageMenu from "./page/language-menu";

import Box from "./contentelements/box";
import Map from "./contentelements/map";
import Places from "./contentelements/places";
import Teaser from "./contentelements/teaser";
import Toggler from "./contentelements/toggler";
import ImageSlider from './contentelements/imageSlider';
import 'focus-visible';

// handle hover for touch devices in css
if (!("ontouchstart" in document.documentElement)) {
  document.documentElement.className += " no-touch";
}

if ([
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)) {
  document.documentElement.className += " is-ios";
}

require('./libs/lazysizes-aspectratio');
require('./libs/lazysizes-modified');

require('./polyfills/request-anim-frame');

let windowEvents = new WindowEvents();
let lanuageMenu = new LanuageMenu();


ImageSlider();

let box = new Box();
let map = new Map();
let teaser = new Teaser();
let toggler = new Toggler();
let places = new Places();



initFormVue();

Usercentrics.init();
Usercentrics.handleJuicer();
Usercentrics.handleVimeo();
Usercentrics.handleYoutube();

